import React from "react";
import PeopleAvatar from "../Assets/PeopleAvatar4.png";

export default function NotificationComponent({
  handleModal,
  handleSettingsModal,
}) {
  return (
    <div
      style={{ boxShadow: "0px 25px 50px -12px rgba(0, 0, 0, 0.25)" }}
      className="w-[420px] py-4 px-3 border-[1px] border-[#F3F4F6]"
    >
      <div className="flex items-center justify-between">
        <p className="text-[1.25rem] font-[500] text-[#374151]">
          Notifications
        </p>
        <p className="text-[0.80rem] text-[#942A27]">Mark all as read</p>
      </div>
      <p className="text-[0.80rem] text-[#6B7280] font-[600] mt-3">Today</p>
      <div className="flex flex-col gap-y-1 gap-x-3 mt-1">
        <div className="flex flex-col items-start justify-between">
          <p className="text-[0.75rem] text-[#6B7280] self-end">Just now</p>
          <div className="text-gray-800 bg-gray-200 hover:bg-gray-100 py-2 px-4 cursor-pointer text-sm font-semibold rounded-md my-2">
            You have been assigned an AI Team. Complete your team profile.
          </div>
        </div>
        <div className="flex flex-col items-start justify-between">
          <p className="text-[0.75rem] text-[#6B7280] self-end">Just now</p>
          <div className="text-gray-800 bg-gray-200 hover:bg-gray-100 py-2 px-4 cursor-pointer text-sm font-semibold rounded-md my-2">
            You have been assigned an AI Team. Complete your team profile.
          </div>
        </div>
        <div className="flex flex-col items-start justify-between">
          <p className="text-[0.75rem] text-[#6B7280] self-end">Just now</p>
          <div className="text-gray-800 bg-gray-200 hover:bg-gray-100 py-2 px-4 cursor-pointer text-sm font-semibold rounded-md my-2">
            You have been assigned an AI Team. Complete your team profile.
          </div>
        </div>
        {/* <div className="flex items-start justify-between">
          <div className="flex items-center gap-3">
            <img className="w-[3rem] h-[3rem]" src={PeopleAvatar} />
            <div className="flex flex-col">
              <p className="text-[0.80rem] text-[#374151] font-[500]">
                Stephanie Fong
              </p>
              <p className="text-[0.80rem] ">
                Commented on{" "}
                <span className="underline underline-offset-1">
                  Website Design Draft
                </span>
              </p>
            </div>
          </div>
          <p className="text-[0.75rem] text-[#6B7280]">Yesterday</p>
        </div> */}
      </div>
      {/* <p className="text-[0.80rem] text-[#6B7280] font-[600] mt-3">Today</p>
      <div className="flex flex-col gap-3 mt-5">
        <div className="flex items-start justify-between">
          <div className="flex items-start gap-3">
            <img className="w-[3rem] h-[3rem]" src={PeopleAvatar} />
            <div className="flex flex-col">
              <p className="text-[0.80rem] text-[#374151] font-[500]">
                Stephanie Fong
              </p>
              <p className="text-[0.80rem] ">
                Commented on{" "}
                <span className="underline underline-offset-1">
                  Website Design Draft
                </span>
              </p>
              <div className="w-fit py-1 px-2 bg-[#FDF6B2] rounded-[4px] mt-2">
                <p className="text-[0.70rem] font-[600] text-[#9F580A]">
                  Pending Approval
                </p>
              </div>
            </div>
          </div>
          <p className="text-[0.75rem] text-[#6B7280]">Just now</p>
        </div>
        <div className="flex items-start justify-between">
          <div className="flex items-center gap-3">
            <img className="w-[3rem] h-[3rem]" src={PeopleAvatar} />
            <div className="flex flex-col">
              <p className="text-[0.80rem] text-[#374151] font-[500]">
                Stephanie Fong
              </p>
              <p className="text-[0.80rem] ">
                Commented on{" "}
                <span className="underline underline-offset-1">
                  Website Design Draft
                </span>
              </p>
              <div className="w-fit py-1 px-2 bg-[#D5F5F6] rounded-[4px] mt-2">
                <p className="text-[0.70rem] font-[600] text-[#047481]">
                  Approved
                </p>
              </div>
            </div>
          </div>
          <p className="text-[0.75rem] text-[#6B7280]">Just now</p>
        </div> */}
      {/* </div> */}
      <button
        className="gap-x-3 w-full border font-medium text-gray-600 py-2 mt-3 transition delay-10 hover:text-white hover:bg-gray-600"
        onClick={(e) => {
          e.stopPropagation();
          handleModal();
          handleSettingsModal(true);
        }}
      >
        Manage
      </button>
    </div>
  );
}
